import { Alert, Button, Stack, Typography } from "@mui/material";

/**
 * Explains why an attached manifest document's data isn't on the manifest yet.
 *
 * Names no reviewer on purpose: whether that is the customer or Encamp depends
 * on the tenant's flags, and the Review action (offered only to whoever may
 * review) is what says which.
 */
export function DocumentReviewBanner({
  awaitingRecompute,
  onView,
  onReview,
  paperName = "manifest",
}: {
  /** What the paper is called in the explainer. */
  paperName?: "manifest" | "bill of lading";
  /** Reviewed, but the manifest hasn't counted the review yet. Hides Review. */
  awaitingRecompute: boolean;
  onView: () => void;
  onReview?: () => void;
}) {
  return (
    <Alert severity="info" variant="outlined" sx={{ mt: 2 }}>
      <Stack spacing={1} alignItems="flex-start">
        <Typography variant="body2">
          {awaitingRecompute
            ? `The document has been reviewed. Its data will appear on this ${paperName} within a minute or two.`
            : `The attached ${paperName === "manifest" ? "manifest document" : "document"} is viewable, but its data won't count toward this ${paperName} until the document has been reviewed.`}
        </Typography>
        <Stack direction="row" spacing={1}>
          <Button size="small" color="inherit" onClick={onView}>
            View document
          </Button>
          {onReview && !awaitingRecompute && (
            <Button size="small" color="inherit" onClick={onReview}>
              Review document data
            </Button>
          )}
        </Stack>
      </Stack>
    </Alert>
  );
}
